import { userService } from '../_services';
import { router } from '../_helpers';

const user = JSON.parse(localStorage.getItem('user'));
const signedupUser = null
const initialState = user
    ? { status: { loggedIn: true }, user }
    : { status: {}, user: null };

export const authentication = {
    namespaced: true,
    state: initialState,
    actions: {
        login({ dispatch, commit }, { username, password, to }) {
            commit('loginRequest', { username });

            userService.login(username, password)
                .then(
                    user => {
                        commit('loginSuccess', user);
                        //console.log( to );
                        if( to ) router.push({ name: to })
                        //this.$emit('closeLoginOverlay')
                    },
                    error => {
                        commit('loginFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
                );
        },
        logout({ commit }) {
            userService.logout();
            commit('logout');
        }
        
        
        
        ,signup({ dispatch, commit},{ firstname, lastname, company, email, password, to }){

          //commit('signupRequest', user);
          userService.signup(firstname, lastname, company, email, password)
              .then(
                    user => {
                        commit('signupSuccess', user);
                        router.push({ name: to });
                    },
                    error => {
                        //commit('signupFailure', error);
                        dispatch('alert/error', error, { root: true });
                    }
              );
        }
        
        
        
        ,checkAuth(){
            userService.checkAuth();
        }
    },
    mutations: {

        loginRequest(state, user) {
            state.status = { loggingIn: true };
            state.user = user;
        },
        loginSuccess(state, user) {
            state.status = { loggedIn: true };
            state.user = user;
        },
        loginFailure(state) {
            state.status = {};
            state.user = null;
        },



        signupSuccess(state, user) {
//             state.status = { signedUp: true };
            state.signedupUser = user.userdata;
        },
        
/*
        signupFailure(state) {
            state.status = {};
            state.user = null;
        },
*/


        logout(state) {
            state.status = {};
            state.user = null;
        }
    }
}